import React, { lazy, Suspense } from "react";

import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import ReportPageAction from "../page-action/ReportPageAction";
const OverdueReportTable = lazy(
  () =>
    import(
      "../../../components/table/all-tables/reportable/overduereport/OverdueReportTable"
    )
);
import { commonText, overdueRE } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";
import { formatDateWithDayjs } from "../../../utils/utils";

export default function OverdueReport() {
  const currentDateStr = new Date();
  const currentDate = formatDateWithDayjs(
    currentDateStr.toISOString(),
    "DD-MMM-YYYY"
  );

  return (
    <>
      <TablePagesTitle mainTitle={overdueRE?.main_title} />

      <ReportPageAction subheading={`${overdueRE?.subH2} ${currentDate}`} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mt-4 mb-2 mx-0">
          <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
            <OverdueReportTable />
          </Suspense>
        </div>
      </ErrorBoundary>
    </>
  );
}
